module.exports = __webpack_public_path__ + "static/media/covid-info-saas.c06e9e37.png";